import { render } from "./DSSAllRecords.vue?vue&type=template&id=6e381b41"
import script from "./DSSAllRecords.vue?vue&type=script&lang=js"
export * from "./DSSAllRecords.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__